import { initializeApp } from 'firebase/app';
import {
  GoogleAuthProvider,
  OAuthProvider,
  getAuth,
  signInWithPopup,
  isSignInWithEmailLink,
  sendSignInLinkToEmail,
  signInWithEmailLink,
} from 'firebase/auth';
import { EMAIL_FOR_SIGN_IN } from './constants';

export class FirebaseAuth {
  private microsoftProvider: OAuthProvider;
  private googleProvider: GoogleAuthProvider;

  private firebaseConfig: { [key: string]: string | undefined } = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
  };

  constructor() {
    initializeApp(this.firebaseConfig);

    this.microsoftProvider = new OAuthProvider('microsoft.com');
    this.microsoftProvider.addScope('mail.read');
    this.googleProvider = new GoogleAuthProvider();
  }

  microsoftAuth = async () => {
    try {
      const auth = getAuth();
      const result = await signInWithPopup(auth, this.microsoftProvider);
      if (!result.user) throw Error('[Microsoft]: User Not Found');

      return await result.user.getIdToken();
    } catch (e) {
      console.log(e);
      return null;
    }
  };

  googleAuth = async () => {
    try {
      const auth = getAuth();
      const result = await signInWithPopup(auth, this.googleProvider);
      if (!result.user) throw Error('[Google]: User Not Found');

      return await result.user.getIdToken();
    } catch (e) {
      console.log(e);
      return null;
    }
  };

  emailLinkSend = async (email: string) => {
    const actionCodeSettings = {
      url: `${window.location.origin}/auth-finish`,
      handleCodeInApp: true,
    };

    try {
      const auth = getAuth();
      await sendSignInLinkToEmail(auth, email, actionCodeSettings);

      window.localStorage.setItem(EMAIL_FOR_SIGN_IN, email);
    } catch (e) {
      console.log(e);
      return null;
    }
  };

  emailLinkFinish = async () => {
    try {
      const auth = getAuth();
      if (isSignInWithEmailLink(auth, window.location.href)) {
        const email = window.localStorage.getItem(EMAIL_FOR_SIGN_IN);

        if (!email) {
          throw Error('Email Not Found');
        }

        const result = await signInWithEmailLink(auth, email, window.location.href);

        window.localStorage.removeItem('emailForSignIn');

        return await result.user.getIdToken();
      }
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  singOut = async () => {
    try {
      const auth = getAuth();
      return auth.signOut();
    } catch (e) {
      console.log(e);
      return e;
    }
  };
}
export const firebaseAuth = new FirebaseAuth();
